/**
 * Estado de erro para Histórico
 */

import React from "react";
import { AlertCircle, RefreshCw } from "lucide-react";

interface HistoricoErrorStateProps {
	error: string | null;
	onRetry: () => void;
}

export function HistoricoErrorState({
	error,
	onRetry,
}: HistoricoErrorStateProps) {
	if (!error) return null;

	return (
		<div className="bg-red-400/10 border border-red-400/20 rounded-lg p-3">
			<div className="flex items-start gap-2">
				<AlertCircle className="w-4 h-4 text-red-400 flex-shrink-0 mt-0.5" />
				<div className="flex-1 min-w-0">
					<div className="text-xs font-medium text-red-400 mb-1">
						Erro ao carregar histórico
					</div>
					<div className="text-xs text-gray-400">{error}</div>
				</div>
				<button
					onClick={onRetry}
					className="p-1.5 text-red-400 hover:text-red-300 transition-colors flex-shrink-0"
					title="Tentar novamente"
				>
					<RefreshCw className="w-4 h-4" />
				</button>
			</div>
		</div>
	);
}
